export const shuffleItems = (items) => items.sort(() => 0.5 - Math.random());

export const hasDuplicate = (arr) => arr.some((val, i) => arr.indexOf(val) !== i);
